import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import moment from 'moment';
import { getreportlist, takereportaction } from '../../actions/users';
import Modal from 'react-modal';
import { IoMdClose } from "react-icons/io";

const ReportList = () => {
    const [userdet, setUser] = useState([]);
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [NFTState, setNFTState] = React.useState(false);
    const [itemId, setItemId ] = useState(0);
    const [ActionMsg, setActionMsg] = useState('')


    const customStyles1 = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
      },
    };

    const ReportCall = async() =>{
      var Arg = {
        reportID:itemId._id,
        actionmsg:ActionMsg,
        nftstate:NFTState,
        action:true
      }
      var Resp = await takereportaction(Arg)
      if(Resp.Success)
        toastAlert("success", Resp.Message)
      else
        toastAlert("error", Resp.Message)
    }

    useEffect(() => {
        getReportList();
    }, []);
    const getReportList = async () => {
        var test = await getreportlist();
        if(test.Success)
          setUser(test.userValue);
        else
          toastAlert("success", "Error on Server")
    }
    const columns = [
        {
    
          key: "_id",
          text: "Report ID",
          className: "answer",
          align: "center",
          sortable: false,
          cell:(rec,index)=>
          <div><p className='text-center exchange_table_values'>{index+1}</p></div>
        },
        {
    
          key: "_id",
          text: "Report ID",
          className: "question",
          align: "center",
          sortable: false,
          cell:(rec)=>
            <div><p className='text-center exchange_table_values'>{rec._id}</p></div>
        },
      {
    
        key: "report",
        text: "Report",
        className: "answer",
        align: "center",
        sortable: false,
        cell:(rec)=>
            <div><p className='text-center exchange_table_values'>{rec.report}</p></div>
      },
      {
        key: "Links",
        text: "Reported NFT",
        className: "answer",
        align: "center",
        sortable: false,
        cell:(rec)=>
            <div className='text-center exchange_table_values'><a href={rec.Links} target="_blank">NFTLink</a></div>
      },
      {
        key: "imageName",
        text: "NFT Name",
        className: "answer",
        align: "center",
        sortable: false,
        cell:(rec)=>
            <div><p className='text-center exchange_table_values'>{rec.imageName}</p></div>
      },
      {
        key: "imageId",
        text: "NFT ID",
        className: "question",
        align: "center",
        sortable: false,
        cell:(rec)=>
            <div><p className='text-center exchange_table_values'>{rec.imageId}</p></div>
      },
      {
        key: "currAddr",
        text: "Report By",
        className: "question",
        align: "center",
        sortable: false,
        cell:(rec)=>
            <div><p className='text-center exchange_table_values'>{rec.currAddr}</p></div>
      },
      {
        key: "imageOwner",
        text: "NFT Owner",
        className: "question",
        align: "center",
        sortable: false,
        cell:(rec)=>
            <div><p className='text-center exchange_table_values'>{rec.imageOwner}</p></div>
      },
      {
        key: "imageContractAddress",
        text: "NFT Contract Address",
        className: "question",
        align: "center",
        sortable: false,
        cell:(rec)=>
            <div><p className='text-center exchange_table_values'>{rec.imageContractAddress}</p></div>
      },
      {
        key: "imageType",
        text: "NFT Type",
        className: "question",
        align: "center",
        sortable: false,
        cell:(rec)=>
            <div><p className='text-center exchange_table_values'>{rec.imageType}</p></div>
      },
      {
        key: "noofitems",
        text: "Owned Quantity",
        className: "question",
        align: "center",
        sortable: false,
        cell:(rec)=>
            <div><p className='text-center exchange_table_values'>{rec.noofitems}</p></div>
      },
      {
        key: "burnToken",
        text: "Burned Quantity",
        className: "question",
        align: "center",
        sortable: false,
        cell:rec=>
        <p className='text-center exchange_table_values'>{rec.burnToken}</p>
      },
      {
        key: "CreatedAt",
        text: "Created At",
        className: "Date",
        align: "center",
        sortable: false,
        cell: record =>
          <div><p className='text-center exchange_table_values'>{moment(record.date).format('MMMM,Do YYYY, hh:mm A')}</p></div>
      },
      {
        key: "nftstate",
        text: "NFT in MarketPlace",
        className: "action",
        width: 100,
        align: "center",
        sortable: false,
        cell:rec=>
        <p className='text-center exchange_table_values'>{(rec.nftstate)?"Hidden":"Visible"}</p>
      },
      {
        key: "action",
        text: "Admin Action status",
        className: "question",
        align: "center",
        sortable: false,
        cell:rec=>
        <p className='text-center exchange_table_values'>{(rec.action)?"Action Taken":"Action Not Taken"}</p>
      },
      {
        key: "actionmsg",
        text: "Admin Action Detail",
        className: "question",
        align: "center",
        sortable: false,
        cell:rec=>
        <p className='text-center exchange_table_values'>{(rec.action)?`${rec.actionmsg}`:"Pending"}</p>
      },
    
      {
        key: "_id",
        text: "Action",
        className: "action",
        width: 100,
        align: "center",
        sortable: false,
        cell:rec=>
        <div className='text-center exchange_table_values'><button onClick={()=>{setNFTState(rec.nftstate);setIsOpen(true);setItemId(rec)}} className="touchapple"> +</button></div>
      }
    
    ];
    const config = {
      page_size: 5,
      length_menu: [10, 20, 50],
      filename: "Users",
      no_data_text: "No user found!",
  
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: <> Previous </>,
          next: <>Next</>,
          last: "Last",
        },
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
      defaultSortAsc: true,
    };
  return (
    <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Report List'} />

                        <div className="common_page_scroller mt-5 pe-2">
                            <div className="page_header">
                                <h2>Report List</h2>
                            </div>
                            <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                                <ReactDatatable
                                    config={config}
                                    records={userdet}
                                    columns={columns}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Modal
                isOpen={modalIsOpen}
                style={customStyles1}
                contentLabel="Example Modal"
            >

              <div className='newthememodal'>
              <div className='text-end'>
                   <button className='closebtns mb-3' onClick={()=>setIsOpen(false)}><IoMdClose className='svgsize'/></button>

                   </div>
              <p className="text-center fw-600">Report ID - {itemId._id}</p>
                <p className="text-center fw-600">Report Action on {itemId.imageName}</p>
                <p className="text-center fw-600">NFT ID - {itemId.imageId}</p>
                <p className="text-center fw-600">NFT in MarketPlace - {(NFTState)?"Hidden":"Visible"}</p>
               <div className="servicemod">
               <textarea
                       type="text"
                       className="form-control primary_inp"
                       id="name"
                       rows="3"
                       onChange={(e)=>setActionMsg(e.target.value)}
                       placeholder="Tell us some details"
                     />
                     <div className="d-flex justify-content-center mt-3">
                   <button className="btn addcate me-2" onClick={()=>setNFTState(!NFTState)}
                    >{(NFTState)?"Show NFT":"Hide NFT"}
                   </button>
                   <button className='btn addcate' onClick={()=>ReportCall()}
                   >Submit
                   </button>
                   </div>
                   <div className='text-center'>
                   <button className='btn addcate' onClick={()=>setIsOpen(false)}>Close</button>

                   </div>
               </div>
               </div>
      </Modal>
        </>
  )
}

export default ReportList